import type { SiteConfig } from "../../api/types";
import { faqAirdrop } from "./faqAirdrop";
import { faqToken } from "./faqToken";
import type { FaqItem } from "./faqTypes";

export type { FaqItem };

/** The token questions run first, then the airdrop ones. */
export function faqItems(config: SiteConfig | null): FaqItem[] {
  return [...faqToken(config), ...faqAirdrop(config)];
}
